<template>
  <div>
    <Breadcrumbs title="salary entry" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-chevron-left btn-primary p-2 clickable" @click='goBack'/>
              <h4 class="mt-2">{{ getSingleSalary.name }}</h4>
              <span>Settlement for: {{ getSingleSalary.month }}</span>
              <span
                >Added at:
                {{ new Date(getSingleSalary.createdAt).toLocaleString() }}</span
              >
            </div>
            <div>
              <div class="col-xl-12 xl-100 news box-col-12">
                <div class="salary">
                  <div slot="headerCustom">
                    <div class="header-top">
                      <h5 class="m-0">Settlement</h5>
                      <div class="card-header-right-icon">
                        <select
                          class="button btn btn-primary"
                          v-model="periodChoosen"
                        >
                          <option>Summary</option>
                          <option>First period</option>
                          <option>Second period</option>
                          <option>Third period</option>
                          <option>Fourth period</option>
                          <option v-if="getSingleSalary.monthLenght === 5">Fifth period</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="periods" v-if="periodChoosen === 'Summary'">
                    <div class="news-update">
                      <h6>To pay</h6>
                      <span>{{ getSingleSalary.doWyplaty }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Average per shift</h6>
                      <span>{{ getSingleSalary.sredniaZmiana }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Shifts number</h6>
                      <span>{{ getSingleSalary.iloscZmian }}</span>
                    </div>
                    <div class="news-update">
                      <h6>Fuel price</h6>
                      <span>{{ getSingleSalary.sumaPaliwa }} PLN</span>
                    </div>
                  </div>
                  <div class="periods" v-if="periodChoosen === 'First period'">
                    <div class="news-update">
                      <h5>
                        {{
                          new Date(getWeeks.period1.start).toLocaleString()
                        }}
                        - {{ new Date(getWeeks.period1.end).toLocaleString() }}
                      </h5>
                    </div>
                    <div class="news-update">
                      <h6>Uber</h6>
                      <span>{{ getSingleSalary.uber1 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Bolt</h6>
                      <span>{{ getSingleSalary.bolt1 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Free Now</h6>
                      <span>{{ getSingleSalary.free1 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Money taken</h6>
                      <span>{{ getSingleSalary.money1 }} PLN</span>
                    </div>
                  </div>
                  <div class="periods" v-if="periodChoosen === 'Second period'">
                    <div class="news-update">
                      <h5>
                        {{
                          new Date(getWeeks.period2.start).toLocaleString()
                        }}
                        - {{ new Date(getWeeks.period2.end).toLocaleString() }}
                      </h5>
                    </div>
                    <div class="news-update">
                      <h6>Uber</h6>
                      <span>{{ getSingleSalary.uber2 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Bolt</h6>
                      <span>{{ getSingleSalary.bolt2 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Free Now</h6>
                      <span>{{ getSingleSalary.free2 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Money taken</h6>
                      <span>{{ getSingleSalary.money2 }} PLN</span>
                    </div>
                  </div>
                  <div class="periods" v-if="periodChoosen === 'Third period'">
                    <div class="news-update">
                      <h5>
                        {{
                          new Date(getWeeks.period3.start).toLocaleString()
                        }}
                        - {{ new Date(getWeeks.period3.end).toLocaleString() }}
                      </h5>
                    </div>
                    <div class="news-update">
                      <h6>Uber</h6>
                      <span>{{ getSingleSalary.uber3 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Bolt</h6>
                      <span>{{ getSingleSalary.bolt3 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Free Now</h6>
                      <span>{{ getSingleSalary.free3 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Money taken</h6>
                      <span>{{ getSingleSalary.money3 }} PLN</span>
                    </div>
                  </div>
                  <div class="periods" v-if="periodChoosen === 'Fourth period'">
                    <div class="news-update">
                      <h5>
                        {{
                          new Date(getWeeks.period4.start).toLocaleString()
                        }}
                        - {{ new Date(getWeeks.period4.end).toLocaleString() }}
                      </h5>
                    </div>
                    <div class="news-update">
                      <h6>Uber</h6>
                      <span>{{ getSingleSalary.uber4 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Bolt</h6>
                      <span>{{ getSingleSalary.bolt4 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Free Now</h6>
                      <span>{{ getSingleSalary.free4 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Money taken</h6>
                      <span>{{ getSingleSalary.money4 }} PLN</span>
                    </div>
                  </div>
                  <div
                    class="periods"
                    v-if="
                      periodChoosen === 'Fifth period'
                    "
                  >
                    <div class="news-update">
                      <h5>
                        {{
                          new Date(getWeeks.period5.start).toLocaleString()
                        }}
                        - {{ new Date(getWeeks.period5.end).toLocaleString() }}
                      </h5>
                    </div>
                    <div class="news-update">
                      <h6>Uber</h6>
                      <span>{{ getSingleSalary.uber5 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Bolt</h6>
                      <span>{{ getSingleSalary.bolt5 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Free Now</h6>
                      <span>{{ getSingleSalary.free5 }} PLN</span>
                    </div>
                    <div class="news-update">
                      <h6>Money taken</h6>
                      <span>{{ getSingleSalary.money5 }} PLN</span>
                    </div>
                  </div>
                  <div slot="footer">
                    <div class="bottom-btn" @click="renderDoc">
                      <a href="#">Print settlement</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}
export default {
  data() {
    return {
      isLoading: false,
      periodChoosen: "Summary",
    };
  },
  created() {
    this.fetchSingleSalary();
  },
  computed: {
    getSingleSalary() {
      return !this.isLoading && this.$store.getters["shifts/getSingleSalary"];
    },
    getWeeks() {
      return !this.isLoading && this.$store.getters["shifts/getWeeks"];
    },
    getUberDetails() {
      let filtredVal = this.getSingleSalary.filter((item) => item === 0);
      console.log(filtredVal);
      return filtredVal;
    },
  },
  methods: {
    async fetchSingleSalary() {
      this.isLoading = true;
      await this.$store.dispatch(
        "shifts/fetchSingleSalary",
        this.$route.params.id
      );
      this.isLoading = false;
    },
    goBack(){
      this.$router.go(-1)
    },
    renderDoc() {
      const that = this;
      loadFile(
        "https://api.rightcloud.pl/uploads/demotemplate_7c15977a93.docx",
        function(error, content) {
          if (error) {
            throw error;
          }
          var zip = new PizZip(content);
          var doc = new Docxtemplater().loadZip(zip);
          doc.setData({
            date: new Date(that.getSingleSalary.createdAt).toLocaleString(),
            name: that.getSingleSalary.name,
            month: that.getSingleSalary.month,
            base: that.getSingleSalary.doWyplaty,
            fuel: that.getSingleSalary.circlek ? (that.getSingleSalary.money1 + that.getSingleSalary.money2 + that.getSingleSalary.money3 + that.getSingleSalary.money4).toFixed(2) : that.getSingleSalary.sumaPaliwa ,
            b1: that.getSingleSalary.bolt1,
            b2: that.getSingleSalary.bolt2,
            b3: that.getSingleSalary.bolt3,
            b4: that.getSingleSalary.bolt4,
            b5: that.getSingleSalary.bolt5 ? that.getSingleSalary.bolt5 : 'Brak',
            f1: that.getSingleSalary.free1,
            f2: that.getSingleSalary.free2,
            f3: that.getSingleSalary.free3,
            f4: that.getSingleSalary.free4,
            f5: that.getSingleSalary.free5 ? that.getSingleSalary.free5 : 'Brak',
            u1: that.getSingleSalary.uber1,
            u2: that.getSingleSalary.uber2,
            u3: that.getSingleSalary.uber3,
            u4: that.getSingleSalary.uber4,
            u5: that.getSingleSalary.uber5 ? that.getSingleSalary.uber5 : 'Brak',
            o1: that.getSingleSalary.okres1,
            o2: that.getSingleSalary.okres2,
            o3: that.getSingleSalary.okres3,
            o4: that.getSingleSalary.okres4,
            m1: that.getSingleSalary.money1,
            m2: that.getSingleSalary.money2,
            m3: that.getSingleSalary.money3,
            m4: that.getSingleSalary.money4,
            ilzmian: that.getSingleSalary.iloscZmian,
            moneyTotal: (that.getSingleSalary.money1 + that.getSingleSalary.money2 + that.getSingleSalary.money3 + that.getSingleSalary.money4).toFixed(2),
            avg: that.getSingleSalary.sredniaZmiana,
            obrot: that.getSingleSalary.obrotTotal,
            podstawa: that.getSingleSalary.podstawaRozliczen,
            circle: that.getSingleSalary.circlek ? "Tak" : "Nie",
            multisport: that.getSingleSalary.multisport ? "Tak" : "Nie",
          });
          try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render();
          } catch (error) {
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
            function replaceErrors(key, value) {
              if (value instanceof Error) {
                return Object.getOwnPropertyNames(value).reduce(function(
                  error,
                  key
                ) {
                  error[key] = value[key];
                  return error;
                },
                {});
              }
              return value;
            }
            console.log(JSON.stringify({ error: error }, replaceErrors));

            if (error.properties && error.properties.errors instanceof Array) {
              const errorMessages = error.properties.errors
                .map(function(error) {
                  return error.properties.explanation;
                })
                .join("\n");
              console.log("errorMessages", errorMessages);
              // errorMessages is a humanly readable message looking like this :
              // 'The tag beginning with "foobar" is unopened'
            }
            throw error;
          }
          var out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          }); //Output the document using Data-URI
          saveAs(
            out,
            `${that.getSingleSalary.name}-${that.getSingleSalary.month}.docx`
          );
        }
      );
    },
  },
};
</script>

<style scoped>
.periods {
  text-align: center;
}
.salary {
  padding: 5%
}
.clickable {
  cursor: pointer;
}
</style>
